var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQustionTracking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 50.0078,
    cy: 50.7422,
    r: 50,
    fill: "#686767"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0078 30.7422C42.2878 30.7422 36.0078 37.0222 36.0078 44.7422C36.0078 55.2422 50.0078 70.7422 50.0078 70.7422C50.0078 70.7422 64.0078 55.2422 64.0078 44.7422C64.0078 37.0222 57.7278 30.7422 50.0078 30.7422ZM51.7678 58.2422H48.2678V54.7422H51.7678V58.2422ZM51.7678 52.5022H48.2678C48.2678 46.8222 53.5078 47.2622 53.5078 43.7422C53.5078 41.8222 51.9278 40.2422 50.0078 40.2422C48.0878 40.2422 46.5078 41.8222 46.5078 43.7422H43.0078C43.0078 39.8822 46.1478 36.7422 50.0078 36.7422C53.8678 36.7422 57.0078 39.8822 57.0078 43.7422C57.0078 48.1222 51.7678 48.5622 51.7678 52.5022Z",
    fill: "#F6EFE9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQustionTracking);
export default __webpack_public_path__ + "static/media/Qustion-tracking.7517944510247f5b68bef36ab5f12a70.svg";
export { ForwardRef as ReactComponent };